import React, { useRef, useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { fetchCreateNews } from '../../../../redux/action/homePage/news/createNews'
import { EditorState, convertToRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import SimpleReactValidator from 'simple-react-validator'
import { useTranslation } from 'react-i18next'

const CreateNews = (props) => {
    const {t} = useTranslation();
    const [btnLoading, setBtnLoading] = useState(false)
    const [forceUpdate, setForceUpdate] = useState(0)
    const [photo, setPhoto] = useState('')
    const [selectedImage, setSelectedImage] = useState();
    const dispatch = useDispatch()
    const create_news = useSelector(state => state.create_news)
    const [editorState, setEditorState] = useState(EditorState.createEmpty())
    const [data, setData] = useState({
        title: '',
        description: '',
    })

    const validator = useRef(new SimpleReactValidator({
        messages: {
          required:"پر کردن این فیلد الزامی است"
        },
    }))

    const handleDataChange = (event) => {
        setData({ ...data, [event.target.name]: event.target.value })
    }

    const onEditorStateChange = (editorState) => {
        setEditorState(editorState);
    };

    const handleSelectImage = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            setSelectedImage(e.target.files[0]);
        }
        setPhoto(e.target.files[0])
    }

    const removeSelectedImage = () => {
        setSelectedImage();
        setPhoto()
    };
    
    const handleFromSubmit = (e) => {
        e.preventDefault()
        setBtnLoading(true)
        if (validator.current.allValid()) {
            const formData = new FormData();
            formData.append('title', data.title)
            formData.append('description', draftToHtml(convertToRaw(editorState.getCurrentContent())))
            formData.append('image', photo)

            setBtnLoading(false)
            dispatch(fetchCreateNews(formData))
            setData({
                title: '',
                description: '',
            })
            props.update()
        } else {
            setBtnLoading(false)
            setForceUpdate(1)
            validator.current.showMessages()
            toast.dismiss()
            toast.error(t("toast_please_fill_in_all_fields") , {position: 'bottom-right',className: 'foo-bar'})
        }
    }

    return (
        <Form className='col-lg-12' onSubmit={handleFromSubmit}>
            <Form.Group className="mb-3 col-lg-7" controlId="formTitle">
                <Form.Label>{t("title")} :</Form.Label>
                <Form.Control type="text" name="title" value={data.title} onChange={handleDataChange}  />
                <span className='validator_error'>{validator.current.message('title', data.title, 'required')}</span>
            </Form.Group>
            <Form.Group className="mb-3 col-lg-7" controlId="formDescription">
                <Form.Label>{t("text")} :</Form.Label>
                <Editor
                    editorState={editorState}
                    wrapperClassName="texteditor-wrapper"
                    editorClassName="texteditor-editor"
                    onEditorStateChange={onEditorStateChange}
                />  
            </Form.Group>
                {selectedImage ? 
                    <div className='selectedImage col-lg-3 col-6'>
                        <img
                            src={URL.createObjectURL(selectedImage)}
                            alt="Thumb"
                        />
                        <button className='btn btn-danger remove_selected_image' type='button' onClick={removeSelectedImage}>
                            <i className='fa fa-times'></i>
                        </button>
                    </div>
                :
                    <div className='selectImage col-lg-3 col-6'>
                        <div className='chooseForm'>
                            <input type="file" className='create_new_image_input' name="photo" value={photo} onChange={handleSelectImage}/>
                            <i className='fa fa-plus'></i>
                            <span>{t("choose picture")}</span>
                        </div>
                    </div>
                }
            <div className='d-flex justify-content-end'>
                <Button variant="secondary" type="button" className='px-4 mt-2 mx-2' onClick={props.close}>
                    {t("return")}
                </Button>
                <Button variant="success" type="submit" className='px-4 mt-2' disabled={btnLoading ? true : false}>
                    {t("submit")}
                </Button>

            </div>
        </Form>
    )
}

export default CreateNews
